import React, { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

import { removeFillUpsQuestionIdFromOptions, updateFillinTheBlanksMultipleAnswer, updateFillintheBlanksSingleAnswer } from "../../../../redux/slices/userActivity";

import "react-edit-text/dist/index.css";
import "./styles.css";
import useWindowDimensions from "../../../../hooks/useWindowDimensions";

const FillUpsAnswers = ({ active, styles, answer_set }) => {
  const dispatch = useDispatch();

  const { selectedUserActivity } = useSelector((state) => state.userActivity);
  const { modalOpen: previewModalOpen, isMobile } = useSelector((state) => state.preview);
  const { width } = useWindowDimensions();

  // console.log(answer_set);

  // SINGLE ANSWER
  const [singleAnswer, setSingleAnswer] = useState(answer_set[0]?.answer.split(""));
  // console.log(singleAnswer);
  const [showHint, setShowHint] = useState(false);
  const inputRefs = useRef([]);
  const hintTimeoutRef = useRef(null);

  const handleSingleInputChange = (value, idx) => {
    const newSingleAnswer = singleAnswer.map((letter, index) => (index === idx ? (value === "" ? " " : value.toLowerCase()) : letter));
    const newAnswerSet = [{ ...answer_set[0], answer: newSingleAnswer.join("") }];

    dispatch(updateFillintheBlanksSingleAnswer({ selectedActivityIdx: selectedUserActivity, answer: newAnswerSet }));
    if (value !== "" && idx < singleAnswer.length - 1) inputRefs.current[idx + 1].focus();
  };
  const handleShowHint = () => {
    clearTimeout(hintTimeoutRef.current);
    if (showHint) {
      setShowHint(false);
      hintTimeoutRef.current = setTimeout(() => {
        const newAnswerSet = [{ ...answer_set[0], hint: answer_set[0]?.hint.map((item, index) => false) }];
        dispatch(updateFillintheBlanksSingleAnswer({ selectedActivityIdx: selectedUserActivity, answer: newAnswerSet }));
      }, 2000);

      return;
    }
    setShowHint(true);
  };

  const handleHintChange = (idx) => {
    // const newAnswerSet = answer_set.map((item, index) => );
    const newAnswerSet = [{ ...answer_set[0], hint: answer_set[0]?.hint.map((item, index) => (index === idx ? !item : item)) }];
    dispatch(updateFillintheBlanksSingleAnswer({ selectedActivityIdx: selectedUserActivity, answer: newAnswerSet }));
  };

  const addSingleInput = () => {
    if (singleAnswer.length >= 20) return;
    const newSingleAnswer = [...singleAnswer, " "];
    const newAnswerSet = [{ ...answer_set[0], answer: newSingleAnswer.join(""), hint: [...answer_set[0]?.hint, false] }];

    dispatch(updateFillintheBlanksSingleAnswer({ selectedActivityIdx: selectedUserActivity, answer: newAnswerSet }));
  };
  const removeSingleInput = () => {
    if (singleAnswer.length === 1) return;
    const newSingleAnswer = singleAnswer.filter((item, idx) => idx < singleAnswer.length - 1);
    const newHint = answer_set[0]?.hint.filter((item, idx) => idx < answer_set[0]?.hint.length - 1);
    const newAnswerSet = [{ ...answer_set[0], answer: newSingleAnswer.join(""), hint: newHint }];

    dispatch(updateFillintheBlanksSingleAnswer({ selectedActivityIdx: selectedUserActivity, answer: newAnswerSet }));
  };

  useEffect(() => {
    const isHintTrue = answer_set[0]?.hint.find((item) => item);
    if (!isHintTrue) return setShowHint(false);
    setShowHint(true);
  }, [active]);

  useEffect(() => {
    if (active.fillUpsSingleAnswer) {
      setSingleAnswer(answer_set[0]?.answer.split(""));
    }
  }, [answer_set]);

  useEffect(() => {
    dispatch(
      removeFillUpsQuestionIdFromOptions({
        selectedActivityIdx: selectedUserActivity,
      })
    );
  }, []);

  // MULTIPLE ANSWER
  const [ans, setAns] = useState(null);

  const submitMultipleInput = (e) => {
    e.preventDefault();
    if (ans.length <= 0) return;
    const newAnswers = [...answer_set, { answer: ans, hint: [] }];
    dispatch(updateFillinTheBlanksMultipleAnswer({ selectedActivityIdx: selectedUserActivity, submittedAnswers: newAnswers }));
    setAns("");
  };

  const removeAns = (i) => {
    const newAnswers = answer_set.filter((item, index) => i !== index);
    dispatch(updateFillinTheBlanksMultipleAnswer({ selectedActivityIdx: selectedUserActivity, submittedAnswers: newAnswers }));
  };

  return (
    <>
      {active.fillUpsSingleAnswer && (
        <div
          className="singleAnswerWrapper"
          style={{ flexDirection: "column", width: "100%", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "50px", pointerEvents: previewModalOpen ? "none" : "all" }}
        >
          {/* <div className="infoLabel" style={styles.alert}>
            <ErrorOutlineIcon sx={{ fontSize: "15px", marginLeft: "11.2px", marginRight: "6px" }} />
            submit the correct answer here.
          </div> */}
          <div className="singleInputContainer" style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", marginTop: "0px", gap: "10px", padding: "10px 30px" }}>
            {singleAnswer?.map((item, index) => {
              return (
                <motion.div
                  initial={{ scale: previewModalOpen ? 1 : 0 }}
                  animate={{ scale: 1, transformOrigin: "left" }}
                  transition={{ duration: 0.2 }}
                  key={index}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "8px",
                    height: showHint ? "60px" : "35px",
                    transition: "all 0.4s cubic-bezier(0.32,-0.06, 0.39, 1.33) 0s",
                  }}
                >
                  <div
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "5.3px",
                      background: "#fff",
                      boxShadow: "inset 1.33333px 2.66667px 2.66667px rgba(0, 0, 0, 0.125)",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <input
                      ref={(ele) => (inputRefs.current[index] = ele)}
                      type="text"
                      maxLength={1}
                      value={item}
                      style={{ width: "70%", background: "transparent", textAlign: "center", height: "26px", borderBottom: "1px solid #00000060", fontSize: "16px" }}
                      onChange={(e) => handleSingleInputChange(e.target.value, index)}
                      onFocus={(e) => e.target.select()}
                      onKeyDown={(e) =>
                        e.key === "Backspace" && e.target.value === "" && index > 0 ? (e.preventDefault(), inputRefs.current[index - 1].focus()) : e.target.value === " " && e.target.select()
                      }
                    />
                  </div>

                  {showHint && (
                    <motion.svg
                      initial={{ scale: previewModalOpen ? 1 : 0, opacity: 0 }}
                      animate={{ scale: 1, opacity: 1 }}
                      transition={{ duration: 0.4, delay: 0.3, ease: "backOut" }}
                      style={{ cursor: "pointer" }}
                      onClick={() => handleHintChange(index)}
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect x="0.25" y="0.25" width="15.5" height="15.5" rx="7.75" fill="white" stroke="#92909A" strokeWidth="0.5" />
                      <AnimatePresence>
                        {answer_set[0]?.hint[index] && (
                          <motion.path
                            initial={{ pathLength: 0 }}
                            animate={{ pathLength: 1 }}
                            exit={{ pathLength: 0 }}
                            transition={{ duration: 0.2, ease: "easeIn" }}
                            d="M3.5 8.5L6.5 11.5L12.5 5.5"
                            stroke="black"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                          />
                        )}
                      </AnimatePresence>
                    </motion.svg>
                  )}
                </motion.div>
              );
            })}
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "20px",
              position: "absolute",
              bottom: " 15px",
              visibility: previewModalOpen ? "hidden" : "visible",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "10px",
              }}
            >
              <svg
                style={{ cursor: "pointer", filter: "drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.25))" }}
                onClick={addSingleInput}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect x="0.25" y="0.25" width="23.5" height="23.5" rx="3.75" fill="#DBD9D9" fillOpacity="0.38" />
                <path d="M11.0927 18.54V13.5H6.14869V11.724H11.0927V6.828H12.9167V11.724H17.8607V13.5H12.9167V18.54H11.0927Z" fill="black" />
                <rect x="0.25" y="0.25" width="23.5" height="23.5" rx="3.75" stroke="#D6CBCB" strokeWidth="0.5" />
              </svg>

              <svg
                style={{ cursor: singleAnswer?.length <= 1 ? "not-allowed" : "pointer", filter: "drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.25))" }}
                onClick={removeSingleInput}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect x="0.25" y="0.25" width="23.5" height="23.5" rx="3.75" fill="#DBD9D9" fillOpacity="0.38" />
                <path d="M8.53547 14.076V12.108H15.4475V14.076H8.53547Z" fill="black" />
                <rect x="0.25" y="0.25" width="23.5" height="23.5" rx="3.75" stroke="#D6CBCB" strokeWidth="0.5" />
              </svg>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <label className="switch">
                <input type="checkbox" checked={showHint} onClick={handleShowHint} />
                <span className="slider" />
              </label>
              <span className="reveal" style={styles.reveal}>
                Add Hint
              </span>
            </div>
          </div>
        </div>
      )}
      {active.fillUpsMultipleAnswer && (
        <div className="bottomMultipleAns" style={{
          ...styles.bottomMultipleAns, width: "auto", pointerEvents: previewModalOpen ? "none" : "all",
          ...(isMobile && previewModalOpen && width > 1275 && { marginLeft: '1rem' }),
        ...(isMobile && previewModalOpen && width > 1275 && { marginRight: '1rem' })
          
        }}
        >
          <div className="alert" style={{ ...styles.alert }}>
            <ErrorOutlineIcon sx={{ fontSize: "15px", marginLeft: "11.2px", marginRight: "6px" }} />
            submit the correct answer here.
          </div>
          <div className="multipleAnsBox" style={styles.multipleAnsBox}>
            <div className="answerM" style={styles.answerM}>
              {answer_set.map((item, index) => {
                return (
                  <div key={index} className="answerBox" style={answer_set.length > 0 ? { ...styles.answerBox, display: "block" } : { display: "none" }}>
                    <span className="ans" style={{ ...styles.ans, padding: "5px 10px" }}>
                      {item.answer}
                    </span>
                    <div className="cancelicon" style={styles.cancelicon} onClick={() => removeAns(index)}>
                      <CancelIcon sx={{ fontSize: "14px" }} />
                    </div>
                  </div>
                );
              })}
            </div>
            {answer_set.length !== 3 && (
              <form action="" style={{ width: "100%" }} onSubmit={(e) => submitMultipleInput(e)}>
                <input
                  className="multipleAnsInput"
                  placeholder="you can enter 3 answers"
                  type="text"
                  name=""
                  id=""
                  value={ans}
                  onChange={(env) => {
                    setAns(env.target.value);
                  }}
                  style={answer_set.length > 0 ? { ...styles.multipleAnsInput, width: "50%" } : { ...styles.multipleAnsInput }}
                />
                <button style={{ display: "none" }}></button>
              </form>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default FillUpsAnswers;
